import { Modal } from "@mantine/core";
import { Navigate, useNavigate, useParams } from "react-router";
import { useAnlageStromstg } from "../../../hooks/useAnlageStromstg";
import { useContainerRef } from "../../../hooks/useContainerRef";
import { ModalFooter } from "../../../mantine/components/ModalFooter/ModalFooter";
import type { Generator } from "../../../utils/backend-types";
import { LoadOrError } from "../../LoadOrError/LoadOrError";
import { GENERATOR_EDIT_TABS } from "../../ObjectModals/GeneratorModal/GeneratorModal.constants";
import { AnlageStromstgFlow } from "./AnlageStromstgFlow";
import "./UpdateAnlageStromstgModal.scss";

const HEADER_TEXT = "Zuordnung der Einheit ändern";

interface UpdateAnlageStromstgModalProps {
  generators?: Array<Generator>;
  isOpen: boolean;
  siteId: number;
  variantId: number;
}

function UpdateAnlageStromstgModal({
  generators,
  isOpen,
  siteId,
  variantId
}: UpdateAnlageStromstgModalProps) {
  const { containerNode, containerRef } = useContainerRef();
  const { componentId } = useParams();
  const navigate = useNavigate();
  const currentGeneratorId = componentId
    ? parseInt(componentId, 10)
    : undefined;
  const currentGenerator = generators?.find((g) => g.id === currentGeneratorId);
  const {
    data: anlageStromstgData,
    isLoading: isAnlageStromstgDataLoading,
    error: anlageStromstgDataError
  } = useAnlageStromstg(currentGenerator?.anlageStromstg);
  const multiSite = Boolean(
    anlageStromstgData?.hasStandortuebergreifendeVerklammerung
  );

  function handleClose() {
    navigate(`../?tab=${GENERATOR_EDIT_TABS.TAB_STROMSTEUER_DATA}`);
  }

  if (!currentGenerator) {
    console.error(
      "UpdateAnlageStromstgModal should only be used with a componentId in the path!"
    );
    return (
      <Navigate to={`../?tab=${GENERATOR_EDIT_TABS.TAB_STROMSTEUER_DATA}`} />
    );
  }

  return (
    <Modal
      className="UpdateAnlageStromstgModal"
      opened={isOpen}
      size="min(80vw, 1200px)"
      title={
        currentGenerator
          ? `${currentGenerator?.name} - ${HEADER_TEXT}`
          : HEADER_TEXT
      }
      onClose={handleClose}
    >
      <LoadOrError
        error={anlageStromstgDataError}
        loading={!currentGenerator || isAnlageStromstgDataLoading}
      >
        {currentGenerator && (
          <AnlageStromstgFlow
            buttonContainer={containerNode}
            currentGenerator={currentGenerator}
            multiSite={multiSite}
            siteId={siteId}
            variantId={variantId}
            onSubmit={handleClose}
          />
        )}
      </LoadOrError>
      <ModalFooter
        className="anlage-stromstg-edit-wizard-buttons"
        ref={containerRef}
      />
    </Modal>
  );
}

export { UpdateAnlageStromstgModal, UpdateAnlageStromstgModalProps };
